import { IStore } from '../../index'

export function getTemplates(state: IStore) {
  return state.templates.templates
}

export function getTemplatesGrouped(state: IStore) {
  return state.templates.grouped
}
